import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="access-denied-shell">
      <div class="access-denied-card">
        <p class="eyebrow">Access Restricted</p>
        <h1>You do not have permission to open this page.</h1>
        <p class="message">
          Your Keycloak login was successful, but this email is not mapped to the
          required dashboard role.
        </p>
        <!-- <a routerLink="/" class="home-link">Return to home</a> -->
      </div>
    </section>
  `,
  styles: [`
    .access-denied-shell {
      min-height: calc(100vh - 180px);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
    }

    .access-denied-card {
      max-width: 640px;
      padding: 32px;
      border-radius: 16px;
      background: #ffffff;
      box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
      border: 1px solid #dbe4f0;
    }

    .eyebrow {
      margin: 0 0 8px;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: #c62828;
    }

    h1 {
      margin: 0 0 12px;
      font-size: 28px;
      line-height: 1.2;
      color: #102a43;
    }

    .message {
      margin: 0 0 20px;
      font-size: 15px;
      line-height: 1.6;
      color: #486581;
    }

    .home-link {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 10px 16px;
      border-radius: 999px;
      background: #c62828;
      color: #ffffff;
      text-decoration: none;
      font-weight: 600;
    }
  `],
})
export class AccessDeniedComponent {}
